// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YyZq9vuWdK8FL8wBFAvf{background:var(--black-10);border-radius:6px;margin-right:4px;padding:4px 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keywordContainer": `YyZq9vuWdK8FL8wBFAvf`
};
export default ___CSS_LOADER_EXPORT___;
